export default __webpack_public_path__ + "static/media/Icons_3.dba25d95.svg";